import { ROUTE_PATH, TEMPLATE_OPTIONS, statusList } from "common/constants/sm-constants";
import { DataModel } from "common/models/utility-models/base-model";
import { FormMetaModel, SmMetaSelectModel, SmMetaInputModel } from "common/models/utility-models/meta-model";

export class StudentsFilterModel extends DataModel {
    batchID: string = '';
    region: string = '';
    branch_name: string = '';
    status: string = '';
    search: string = '';
}


